<template>
<!-- 咨询经历 -->
  <div class="experience-main">
      <div class="bar"><div></div></div>
      <div class="textarea-main">
          <div class="title"><span></span>近期是否有过相关问题的咨询经历，如果有，情况如何？</div>
          <textarea  v-model="text" placeholder="比如，咨询师的建议，自己的感受，其他人的建议：" ></textarea>
      </div>
        <!--  -->
      <div class="footer">
          <button @click="saveHandle()">下一步</button>
      </div>
  </div>
</template>

<script>
import { orderList,saveInfo } from "@/api/xuandui_gadgets"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            place:'',
            text:''
        }
    },
    methods:{
        // 提交填写数据
        saveHandle(){
            
        },
        // 初始化获取数据
        pullData(){
            document.title = '咨询经历';
            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style lang="scss" scoped>
    .experience-main{
        padding: 0px 0px 140px;
        .bar{
            background-color: #ECECEC;
            height: 8px;
            div{
                width: 300px;
                height: 100%;
                background: #46A3FA;
            }
        }
        .textarea-main{
            font-size: 30px;
            background: #FFFFFF;
            border-radius: 20px;
            position: relative;
            padding: 46px 30px;
            .title{
                font-weight: bold;
                color: #2B333A;
                font-size: 30px;
                margin-bottom: 26px;
                display: flex;
                span{
                    width: 6px;
                    height: 30px;
                    background: #46A3FA;
                    border-radius: 6px;
                    margin-right: 20px;
                    margin-top: 8px;
                }
            }
            textarea{
                width: 100%;
                min-height: 700px;
                font-size: 30px;
                border-radius: 20px;
                padding: 36px 30px;
                outline: none;
                resize: none;
                border: none;
                background: #F7F8F9;
            }
        }
        .footer{
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            max-width: 750px;
            background-color: #FFFFFF;
            button{
                width: 670px;
                height: 80px;
                background: #46A3FA;
                border-radius: 40px;
                font-size: 32px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 44px;
                letter-spacing: 1px;
                border: none;
            }
        }
    }
</style>